<template>
  <div class="mask-carousel">
    <div class="mask"></div>
    <div class="carousel">
		<div class="carItem" v-for="(item, index) in list" :key="index" :class="{ active: activeIndex === index }">
			<img v-if="item.type == 'img' || !item.type" :src="item.imgSrc" >
			<video v-if="item.type == 'video'" :poster="item.videoSrc+'?vframe/jpg/offset/1'" controls="controls" controlslist="nodownload noplaybackrate">
				<source :src="item.videoSrc" type="video/mp4"/>
			</video>
		</div>
    </div>
    <div class="page-buttons" v-if="list.length>1">
	  <span class="prev-button" @click="changePage('prev')" :class="activeIndex==0 ? 'disabled' :'' ">
		  <img src="../../static/prevBtn.png"/>
	  </span>
     <!-- <span :class="{disabled:activeIndex==0}" class="prev-button" @click="changePage('prev')">
		  <img src="../../static/nextBtn.png"/>
	  </span> -->
	  <span v-for="(item, index) in list" :key="index" :class="{ active: activeIndex === index }">
		  
	  </span>
	  <span :class="activeIndex==list.length-1 ? 'disabled':''"  class="next-button" @click="changePage('next')">
	  		<img src="../../static/nextBtn.png"/>
	  </span>
      <!-- <button :class="{disabled:activeIndex!=list.length-1}" class="next-button" @click="changePage('next')">&gt;</button> -->
    </div>
    <div class="close-button" @click="closeModal()"><img src="../../static/closeBtn.png"/></div>
  </div>
</template>

<script>
  export default {
    name: 'MaskCarousel',
    props: {
		list: {
			type: Array,
			required: true
		},
    },
	data(){
		return{
			activeIndex: 0
		}
	},
    computed: {
		visiblePrev() {
			return this.list.length > 1
		},
		visibleNext() {
			return this.list.length > 1
		}
    },
	methods:{
		changePage(type){
			this.activeIndex = type==='prev' ? this.activeIndex-1 : this.activeIndex+1 ;
		},
		closeModal(){
			this.$parent.hideModal();
		}
	}
  }
</script>

<style lang="less" scoped>
	// @import '~bootstrap/dist/css/bootstrap.css';
	@import '../assets/css/index';
	@import '../assets/css/style';
	
  .mask-carousel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;

    .mask {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
	  background-color: #000000;
      // background: rgba(0, 0, 0, 1);
    }

    .carousel {
      position: relative;
	  width: 100%;
	  height: 100%;
      // max-width: 80%;
      // max-height: 80%;
      text-align: center;
	  .carItem{
			display: none;
			&.active{
				display: inline-block;
				height:100%;
			}
			video {
				max-width: 100%;
				max-height: 100%;
				position: relative;
				top: 50%;
				transform: translateY(-50%);
		  }
	  }
      img {
        max-width: 100%;
        max-height: 100%;
      }
    }

    .page-buttons {
      position: absolute;
      bottom: 42/@r;
      left: 50%;
      transform: translateX(-50%);
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	  .prev-button,.next-button{
		   .scale(43*180/63,43);
		   background-color: transparent;
		   &.disabled{
				background: rgba(255, 255, 255, 0.3);
				cursor: not-allowed;
				filter: brightness(0.5);
				pointer-events: none;
		   }
	  }
	  span{
		 .scale(13,13);
		  border-radius: 50%;
		  display: inline-block;
		  background-color: #8b8b8b;
		  margin: 0 10/@r;
		  &.active{
			  .scale(31,13);
			  background-color: #fff;
			  border-radius: 10px;
		  }
	  }
      button {
      }
    }

    .close-button {
      position: absolute;
      top: 20/@r;
      right: 32/@r;
      font-size: 40/@r;
      cursor: pointer;
      transition: color 0.3s;
	  .scale(58,58);
      &:hover {
        color: #d9534f;
      }
    }
  }
</style>
